import { render, staticRenderFns } from "./BranchPostIndexReportComponent.vue?vue&type=template&id=6fd9d4e7&scoped=true"
import script from "./BranchPostIndexReportComponent.vue?vue&type=script&lang=js"
export * from "./BranchPostIndexReportComponent.vue?vue&type=script&lang=js"
import style0 from "./BranchPostIndexReportComponent.vue?vue&type=style&index=0&id=6fd9d4e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd9d4e7",
  null
  
)

export default component.exports